import type { ReactNode } from 'react'

/** The frame the Haven Cards Spec draws around a widget in the chat. */
export const WidgetCard = ({ children }: { children: ReactNode }) => (
  <div className="flex flex-col gap-4 rounded-[16px] border border-neutral-200 bg-neutral-0 p-4 shadow-sm">
    {children}
  </div>
)
